import { Tabs, Tab } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const BreadCrumbs = styled.span`
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

export const StyledLink = styled(Link)`
    color: ${(props) => props.theme.colors.primary.main};
`;

export const StyledTabs = styled(Tabs)`
    width: 100%;
    display: flex;
`;

export const StyledTab = styled(Tab)`
    flex-grow: 1;
    text-transform: none;
    font-size: 1rem;
`;

export const Spacer = styled.span`
    margin: 0 1rem;
`;
